import { CogsCards } from '@/feature/financial-model/ecommerce/cogs/components/CogsCards'

const CogsSetupRoute = () => <CogsCards tab='setup' />

export default CogsSetupRoute
